var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChequeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.1021 29.4566H7.98854C7.20812 29.4557 6.45993 29.1452 5.9081 28.5934C5.35626 28.0416 5.04584 27.2934 5.04492 26.5129V8.94373C5.0458 8.1633 5.35621 7.41508 5.90805 6.86322C6.4599 6.31135 7.2081 6.00091 7.98854 6H43.1021C43.8825 6.00091 44.6307 6.31135 45.1826 6.86322C45.7344 7.41508 46.0448 8.1633 46.0457 8.94373V26.5129C46.0448 27.2934 45.7344 28.0416 45.1826 28.5934C44.6307 29.1453 43.8825 29.4557 43.1021 29.4566Z",
    fill: "#EFF1F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.0572 33.5021H3.94362C3.16326 33.5012 2.41513 33.1908 1.8633 32.6391C1.31147 32.0873 1.00101 31.3392 1 30.5588V12.9896C1.00088 12.2092 1.31129 11.461 1.86313 10.9091C2.41497 10.3573 3.16318 10.0468 3.94362 10.0459H39.0572C39.8376 10.0468 40.5858 10.3572 41.1377 10.9091C41.6895 11.4609 41.9999 12.2092 42.0008 12.9896V30.5588C41.9998 31.3392 41.6894 32.0873 41.1375 32.6391C40.5857 33.1909 39.8375 33.5012 39.0572 33.5021Z",
    fill: "#DADFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.4445 28.1475C20.1726 28.1475 18.9293 27.7704 17.8717 27.0637C16.8142 26.3571 15.9899 25.3528 15.5032 24.1777C15.0165 23.0026 14.8891 21.7096 15.1372 20.4621C15.3854 19.2147 15.9979 18.0688 16.8972 17.1694C17.7966 16.2701 18.9424 15.6576 20.1899 15.4095C21.4374 15.1613 22.7304 15.2887 23.9055 15.7754C25.0805 16.2621 26.0849 17.0864 26.7915 18.1439C27.4982 19.2015 27.8753 20.4448 27.8753 21.7167C27.8734 23.4217 27.1952 25.0563 25.9897 26.2619C24.7841 27.4675 23.1495 28.1456 21.4445 28.1475ZM21.4445 17.6665C20.6434 17.6665 19.8603 17.9041 19.1942 18.3491C18.5282 18.7942 18.009 19.4268 17.7025 20.1669C17.3959 20.907 17.3157 21.7214 17.472 22.5071C17.6283 23.2927 18.0141 24.0144 18.5805 24.5809C19.147 25.1473 19.8687 25.5331 20.6544 25.6893C21.4401 25.8456 22.2545 25.7654 22.9946 25.4588C23.7347 25.1522 24.3672 24.6331 24.8123 23.967C25.2573 23.3009 25.4948 22.5178 25.4948 21.7167C25.4936 20.6429 25.0665 19.6134 24.3071 18.8541C23.5478 18.0948 22.5183 17.6677 21.4445 17.6665Z",
    fill: "url(#paint0_linear_1654_16391)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1654_16391",
    x1: 35.426,
    y1: 35.6984,
    x2: 16.6976,
    y2: 16.9699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequeImage);
export default __webpack_public_path__ + "static/media/ChequeImage.0d6c68b881e727ab008afc3d4a8ecec8.svg";
export { ForwardRef as ReactComponent };